export const LAUNCH_DARKLY_CONFIG = {
  clientSideID: process.env.NX_PUBLIC_LAUNCH_DARKLY_CLIENT_ID,
  options: {
    bootstrap: 'localStorage',
  }
};

export default LAUNCH_DARKLY_CONFIG;
